import React, { useState } from 'react';
import { useFetch } from '../../lib/useFetch';
import { Card, Tabs, Button, Dimmer, Form, Tab, Grid, Tag, Avatar, Table } from "tabler-react";
import { formatDate } from '../../lib/helpers';
import { useLocation } from 'react-router-dom';
import { userImg } from '../../lib/constants';
import PhotoModal from '../../components/modal/photoModal';
import Offers from '../offers';

const tableHeaders = ["Shopper", "Pick Up", "Destination", "Status"];

const TripViewModal = ({ recordId, closeMainModal }) => {
  const { data, loading } = useFetch(`trips/${recordId}`);
  const { data: shipments } = useFetch(`shipments?tripId=${recordId}&sort=createdAt:-1`, recordId);
  const [modalPhoto, setModalPhoto] = useState(null)
  const { pathname } = useLocation()

  return (
    <Card>
      {modalPhoto &&
        <PhotoModal photo={data.owner.photo} close={() => setModalPhoto(null)} />
      }

      <Dimmer active={loading} loader={loading}>
        <Card.Header>
          <Card.Title>Trip Details</Card.Title>
          <Card.Options>
            <Button size="sm" icon="x" onClick={() => closeMainModal()} />
          </Card.Options>
        </Card.Header>
        {!loading && data &&
          <Card.Body>
            <Form>
              <Tabs initialTab="Trip Details">
                <Tab title="Trip Details">
                  <Form.FieldSet>
                    <Grid.Row>
                      <Grid.Col>
                        <Form.Label>Pick Up</Form.Label>
                        <div className="normalText">{data.fromCity.countryName}, {data.fromCity.name}</div>

                        <Form.Label>Destination</Form.Label>
                        <div className="normalText">{data.toCity.countryName}, {data.toCity.name}</div>

                        <Form.Label>Trip Date</Form.Label>
                        <div className="normalText">{formatDate(new Date(data.tripDate))}</div>

                        <Form.Label>Status</Form.Label>
                        <div className="normalText">{data.state}</div>
                      </Grid.Col>

                      <Grid.Col>
                        <Form.Label>Trip Capacity</Form.Label>
                        <div className="normalText">{data.tripCapacity}</div>

                        <Form.Label>Trip Type</Form.Label>
                        <div className="normalText">{data.tripType}</div>

                        <Form.Label>Vehicle Type</Form.Label>
                        <div className="normalText">{data.vehicleType}</div>

                        <Form.Label>Milestone</Form.Label>
                        <div className="normalText">{data.milestone}</div>
                      </Grid.Col>
                    </Grid.Row>
                  </Form.FieldSet>
                </Tab>

                <Tab title="Booking Info">
                  <Form.FieldSet>
                    <Grid.Row>
                      <Grid.Col>
                        <Form.Label>First Name</Form.Label>
                        <div className="normalText">{data.owner.firstName}</div>

                        <Form.Label>Last Name</Form.Label>
                        <div className="normalText">{data.owner.lastName}</div>
                      </Grid.Col>

                      {data.vehicleType === 'Airline' &&
                        <Grid.Col>
                          <Form.Label>Airline</Form.Label>
                          <div className="normalText">{data.flightInfo?.airline}</div>

                          <Form.Label>Flight #</Form.Label>
                          <div className="normalText">{data.flightInfo?.flightNo}</div>
                        </Grid.Col>
                      }
                    </Grid.Row>

                    <Form.Label>Notes</Form.Label>
                    <div className="normalText">{data.notes}</div>

                    <Form.Label>Unwanted Categories</Form.Label>
                    {!data.notCarriedCategories || data.notCarriedCategories.length === 0 ?
                      <div className="normalText">No Categories</div> :
                      <Tag.List>
                        {data.notCarriedCategories.map(item =>
                          <Tag>{item.name}</Tag>
                        )}
                      </Tag.List>
                    }
                  </Form.FieldSet>
                </Tab>

                {(pathname.includes('progress') || pathname.includes('completed')) &&
                  <Tab title="Shipments">
                    <Table hasOutline striped>
                      <Table.Header>
                        {tableHeaders.map((head, i) => (
                          <Table.ColHeader key={`tableHeader-${i}`}>{head}</Table.ColHeader>
                        ))}
                      </Table.Header>
                      <Table.Body>
                        {shipments && shipments.map((s, i) => (
                          <Table.Row key={i}>
                            <Table.Col>
                              <Avatar size="sm" imageURL={s.owner.photo || userImg} />
                              &nbsp;
                              {s.owner.username}
                            </Table.Col>

                            <Table.Col>
                              {s.fromCity.name}
                            </Table.Col>

                            <Table.Col>
                              {s.toCity.name}
                            </Table.Col>

                            <Table.Col>
                              {s.state}
                            </Table.Col>
                          </Table.Row>
                        ))}
                      </Table.Body>
                    </Table>
                  </Tab>
                }

                {(pathname.includes('progress') || pathname.includes('completed')) &&
                  <Tab title="Offers">
                    <Offers params={`tripId=${data._id}`} />
                  </Tab>
                }

                <Tab title="Traveller Info">
                  <Form.FieldSet>
                    <Grid.Row>
                      <Grid.Col>
                        <Form.Label>User Photo</Form.Label>
                        <Avatar size="md" imageURL={data.owner.photo} className="mb-2 clickable"
                          onClick={() => setModalPhoto(data.owner.photo)} />

                        <Form.Label>Name</Form.Label>
                        <div className="normalText">{`${data.owner.firstName} ${data.owner.lastName}`}</div>

                        <Form.Label>Username</Form.Label>
                        <div className="normalText">{data.owner.username}</div>

                        <Form.Label>Phone Number</Form.Label>
                        <div className="normalText">{data.owner.phoneNumber}</div>
                      </Grid.Col>

                      <Grid.Col >
                        <Form.Label>Email</Form.Label>
                        <div className="normalText">{data.owner.email}</div>
                      </Grid.Col>

                      <Grid.Col>
                        <Form.Label>Balance</Form.Label>
                        <div className="normalText">{data.owner.balance}</div>

                        <Form.Label>Is Phone Verified</Form.Label>
                        <div className="normalText">{data.owner.isPhoneVerified ? 'Yes' : 'No'}</div>

                        <Form.Label>Is Passport Verified</Form.Label>
                        <div className="normalText">{data.owner.isPassportVerified ? 'Yes' : 'No'}</div>

                        <Form.Label>Is Payment Verified</Form.Label>
                        <div className="normalText">{data.owner.isPaymentVerified ? 'Yes' : 'No'}</div>
                      </Grid.Col>
                    </Grid.Row>

                    <Form.Label>Roles</Form.Label>
                    <Tag.List>
                      {data.owner.roles.map(item =>
                        <Tag>{item}</Tag>
                      )}
                    </Tag.List>
                  </Form.FieldSet>
                </Tab>
              </Tabs>
            </Form>
          </Card.Body>
        }
      </Dimmer>
    </Card>
  )
}

export default TripViewModal;